import * as $ from 'jquery';

export function twistoCheck() {
    if ("undefined" === typeof Twisto) {
        throw new Error('Twisto library not found');
    }
    let payloadElement = $('[data-twisto-check-payload]');
    if (!payloadElement.length) {
        throw new Error('Payload element not found')
    }

    function submitCheckoutForm() {
        $('.js-checkout-complete-order-button').click();
    }

    $('.js-twisto-modal').click();
    $('form[name="checkout"]').addClass('loading');
    Twisto.check(
        payloadElement.first().data('twisto-check-payload'),
        function (response) {
            for (let property in response) {
                if (response.hasOwnProperty(property)) {
                    $(document).find('[name*="[twisto][' + property + ']"]').val(response[property]);
                }
            }
            submitCheckoutForm();
        },
        function () {
            $(document).find('[name*="[twisto][status]"]').val('error');
            $(document).find('[name*="[twisto][transaction_id]"]').val('error');
            submitCheckoutForm();
        }
    )
}
